import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  rank: 0,
};

const leaderboardSlice = createSlice({
  name: "leaderboard",
  initialState,
  reducers: {
    studentRank: (state, action) => {
      state.rank = action.payload;
    },
  },
});

export const { studentRank } = leaderboardSlice.actions;
export default leaderboardSlice.reducer;
